import { Routes } from '@angular/router';
import { ICmsMetaComponent } from './icms-meta.component';

export const icmsMetaRoutes: Routes = [
    {
        path: '_icms-meta',
        component: ICmsMetaComponent
    }
];
